"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalStyles = exports.PageStyle = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const fonts_1 = require("./fonts");
exports.PageStyle = (0, styled_components_1.createGlobalStyle) `
html {
  font-size: 14px;
  font-family: AvantGarde,sans-serif;
  body {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
}`;
function GlobalStyles() {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(fonts_1.GlobalFonts, null),
        react_1.default.createElement(exports.PageStyle, null)));
}
exports.GlobalStyles = GlobalStyles;
//# sourceMappingURL=main.js.map